import { createAsyncThunk } from "@reduxjs/toolkit";
import { CustomAction } from "../../../store/customAction";
import { Api } from "../../../";
import {
  IAgentPolicyMetricsRequestBody,
  IAgentPolicyMetricsResponse,
} from "../../../models/agent/policiesListing";
import { API_POST_AGENT_POLICY_METRICS } from "../../../Apis/ApiEndPoints";

export const GetPolicyMetrics = createAsyncThunk(
  "agent/policyMetrics",
  async (requestBody: IAgentPolicyMetricsRequestBody, { dispatch }) => {
    const response: IAgentPolicyMetricsResponse = await CustomAction(
      Api.post(API_POST_AGENT_POLICY_METRICS, requestBody),
      dispatch,
      "agent/policyMetrics"
    );

    return response;
  }
);
